import axios from "axios";

const instance = axios.create({
  baseURL: "https://aidcec-analytics.eduhk.hk/ai-analyzer-api",
  headers: {
    "Content-Type": "application/json",
  },
});

// const instance = axios.create({
//   baseURL: "https://localhost:180",
//   headers: {
//     "Content-Type": "application/json",
//   },
// });

export default instance;
